import { useMutation, useQuery } from "@apollo/client";
import React, { useEffect, useState } from "react";
import {Button, Card, Form, FormControl} from "react-bootstrap";
import { toast } from "react-toastify";
import { setInputFilter } from "../../../utils/helpers/utils";
import QUERY from "../../../utils/service/query";
import {FormControlLabel, Switch, TextField} from "@mui/material";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import moment from "moment";

const PromoLovitzConfiguration = () => {
    const { data } = useQuery(QUERY.CONFIG.GET_PROMO_LOVITZ_CONFIG);
    const [updateConfig] = useMutation(QUERY.CONFIG.UPDATE_PROMO_LOVITZ_CONFIG);


    const [originalData, setOriginalData] = useState({
        status:false,
        count:0,
        endTime:new Date()
    });
    const [configCurrent, setConfigCurrent] = useState({...originalData});


    useEffect(()=>{
        if(data && data.getLovitzConfig){
            setOriginalData({...data.getLovitzConfig, endTime:new Date(parseFloat(data.getLovitzConfig.endTime))})
            setConfigCurrent({...data.getLovitzConfig, endTime:new Date(parseFloat(data.getLovitzConfig.endTime))})
        }
    },[data])
    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setConfigCurrent(s=>{return {...s,status:event.target.checked}});
    };
    const isEqual = ()=>{
        let equal = configCurrent.status === originalData.status && configCurrent.count === originalData.count && configCurrent.endTime === originalData.endTime
        return equal
    }

    return (
        <>
            <Card className="mb-3">
                <Card.Header>
                    <h5>Promotional Lovitz Configuration</h5>
                </Card.Header>
                <Card.Body className="bg-light">
                    <div>
                    <FormControlLabel label="Promotional Lovitz Enabled" labelPlacement={"start"} control={<Switch
                        checked={configCurrent.status}
                        onChange={handleChange}
                    />}  />
                    </div>
                    <div style={{margin:15}}>
                        <TextField id="outlined-basic" inputProps={{  min: 0}} label="Amount of Lovitz to be gifted" variant="outlined" onChange={(e)=>{
                            setConfigCurrent(s=>{return{...s,count: parseInt(e.target.value)}})
                        }} value={configCurrent.count} type={"number"} disabled={!configCurrent.status} />
                    </div>
                    <div style={{margin:15}}>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DateTimePicker
                                disabled={!configCurrent.status}
                                renderInput={(props) => <TextField {...props} />}
                                inputFormat="DD-MM-YYYY"
                                label="Promotional Lovitz End Date"
                                value={configCurrent.endTime}
                                onChange={(newValue) => {
                                    if(newValue) {
                                        setConfigCurrent(s => {
                                            return {...s, endTime: newValue}
                                        });
                                    }
                                }}
                            />
                        </LocalizationProvider>
                    </div>
                        <Button
                            disabled={isEqual()}
                            className="mt-2"
                            variant="primary"
                            type="button"
                            onClick={(e) => {
                                console.log("current ",new Date(configCurrent.endTime).getTime().toString())
                                updateConfig({
                                    variables: {
                                        config:{
                                            count:configCurrent.count,
                                            status:configCurrent.status,
                                            endTime:new Date(configCurrent.endTime).getTime().toString()
                                        }
                                    },
                                })
                                    .then(({data}) => {
                                        if(data && data.lovitzConfigUpdate){
                                            setOriginalData({...data.lovitzConfigUpdate, endTime:new Date(parseFloat(data.lovitzConfigUpdate.endTime))})
                                            setConfigCurrent({...data.lovitzConfigUpdate, endTime:new Date(parseFloat(data.lovitzConfigUpdate.endTime))})
                                        }
                                        toast.dismiss();
                                        toast.success("Configuration updated successfully");
                                    })
                                    .catch(() => {
                                        toast.dismiss();
                                        toast.error("Something went wrong!");
                                    });

                            }}>
                            Save
                        </Button>
                </Card.Body>
            </Card>
        </>
    );
};

export default PromoLovitzConfiguration;
